<template>
  <div class="tab-container">
    <slot></slot>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.tab-container {
  display: flex;
  width: 100%;
  margin: $spacer * 0.5 0 $spacer * 1.5;

  border-radius: 3px;
  background-color: white;
  box-shadow: 0 0 30px 0 rgba(82, 63, 105, 0.05);

  .tab-item {
    padding: $spacer $spacer * 1.5 $spacer * 0.65;
    cursor: pointer;
    transition: all 0.2s ease-out;

    &.active,
    &:hover {
      color: $gray-700;
      border-bottom: 2px solid $gray-600;
    }

    &:hover {
      background-color: $gray-100;
    }
  }
  .sync-tab:hover  {
    border-bottom: 0;
    background-color: transparent;
  }
}

@media (max-width: 575.98px) {
  .tab-container {
    overflow-x: auto;
    .tab-item {
      flex: 0 0 40%;
      padding: $spacer $spacer * 0.85;
      cursor: pointer;
      transition: all 0.2s ease-out;
      text-align: center;
      &:first-child {
        padding-left: 0;
      }
      &:nth-child(n+3):last-child {
        padding-right: 0;
      }
    }

  }
}
</style>
